// Mock data for Math Tutoring Landing Page

export const services = [
  {
    id: 1,
    title: "Cálculo",
    description: "Domina límites, derivadas, integrales y ecuaciones diferenciales con explicaciones claras y ejercicios prácticos.",
    icon: "Calculator",
    topics: ["Límites y continuidad", "Derivadas", "Integrales", "Series y sucesiones"]
  },
  {
    id: 2,
    title: "Estadística",
    description: "Aprende probabilidad, distribuciones, inferencia estadística y análisis de datos de forma sencilla.",
    icon: "BarChart3",
    topics: ["Probabilidad", "Distribuciones", "Inferencia", "Regresión"]
  },
  {
    id: 3,
    title: "Física",
    description: "Comprende mecánica, termodinámica, electromagnetismo y ondas con ejemplos del mundo real.",
    icon: "Atom",
    topics: ["Mecánica clásica", "Termodinámica", "Electromagnetismo", "Ondas"]
  },
  {
    id: 4,
    title: "Mecánica de Materiales",
    description: "Resuelve problemas de esfuerzos, deformaciones, vigas y estructuras con metodología paso a paso.",
    icon: "Wrench",
    topics: ["Esfuerzo y deformación", "Vigas", "Torsión", "Columnas"]
  }
];

export const features = [
  {
    id: 1,
    title: "Resolución en Línea",
    description: "Envía tu problema y recibe la solución detallada paso a paso",
    icon: "Monitor"
  },
  {
    id: 2,
    title: "Respuesta Rápida",
    description: "Soluciones en menos de 24 horas para tus exámenes",
    icon: "Clock"
  },
  {
    id: 3,
    title: "Explicación Completa",
    description: "No solo la respuesta, sino todo el procedimiento explicado",
    icon: "BookOpen"
  },
  {
    id: 4,
    title: "Soporte por WhatsApp",
    description: "Comunicación directa para resolver tus dudas al instante",
    icon: "MessageCircle"
  }
];

export const pricing = {
  price: 30,
  currency: "S/.",
  unit: "por examen",
  questions: 4,
  includes: [
    "Resolución de 4 problemas",
    "Procedimiento paso a paso",
    "Explicación detallada",
    "Entrega en menos de 24 horas",
    "Soporte para dudas"
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "María García",
    university: "Universidad Nacional",
    comment: "Gracias a Alex pude aprobar Cálculo II. Sus explicaciones son muy claras.",
    rating: 5
  },
  {
    id: 2,
    name: "Carlos López",
    university: "Universidad de Ingeniería",
    comment: "Excelente servicio, me ayudó con Mecánica de Materiales cuando más lo necesitaba.",
    rating: 5
  },
  {
    id: 3,
    name: "Ana Rodríguez",
    university: "Universidad Privada",
    comment: "Las soluciones son muy detalladas y fáciles de entender. 100% recomendado.",
    rating: 5
  }
];

export const tutorInfo = {
  name: "Alex Arana Rabanal",
  title: "Tutor de Matemáticas Universitarias",
  description: "Especialista en enseñanza de matemáticas y física para estudiantes universitarios. Mi objetivo es que comprendas cada concepto y logres tus metas académicas.",
  whatsapp: "+51999999999"
};

export const navLinks = [
  { id: 1, label: "Inicio", href: "#inicio" },
  { id: 2, label: "Servicios", href: "#servicios" },
  { id: 3, label: "Cómo Funciona", href: "#como-funciona" },
  { id: 4, label: "Precios", href: "#precios" },
  { id: 5, label: "Contacto", href: "#contacto" }
];
